import { useBack, useBackMultipart } from "../http";
import { EpiEmployeeSelectionDTO } from "../types/EpiEmployeeSelectionDTO";
import { EpiInspectionFlowDTO, EpiInspectionItemDTO } from "../types/EpiInspectionFlowDTO";
import { EpiPanelDetailDTO } from "../types/EpiPanelDetailDTO";

export class EpiInspectionFlowService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async listEmployees(companyId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiEmployeeSelectionDTO[]>(`/epi-inspections/employees/${companyId}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os colaboradores da empresa`, error);
			return undefined;
		}
	}

	async get(inspectionId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter a inspeção`, error);
			return undefined;
		}
	}

	async listPendingExams(inspectionId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiPanelDetailDTO[]>(`/epi-inspections/flow/${inspectionId}/pending-exams`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as pendências de exame`, error);
			return undefined;
		}
	}

	async createOrResume(employeeId: number) {
		const response = await this.axiosInstance
			.post<EpiInspectionFlowDTO>(`/epi-inspections/flow/employee/${employeeId}`);
		return { ...response };
	}

	async saveStep(inspectionId: number, currentStep: number, generalObservation: string,
			items: EpiInspectionItemDTO[]) {
		const response = await this.axiosInstance
			.put<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}/step`,
				{ currentStep, generalObservation, items });
		return { ...response };
	}

	async acknowledge(inspectionId: number, declarationText: string, declarationVersion: string) {
		const response = await this.axiosInstance
			.post<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}/acknowledgement`,
				{ declarationText, declarationVersion });
		return { ...response };
	}

	async acknowledgeExams(inspectionId: number, declarationText: string,
			declarationVersion: string, pendingExamsSnapshot: string) {
		const response = await this.axiosInstance
			.post<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}/exam-acknowledgement`,
				{ declarationText, declarationVersion, pendingExamsSnapshot });
		return { ...response };
	}

	async sign(inspectionId: number, form: FormData) {
		const response = await this.axiosInstanceMultipart
			.post<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}/signature`, form);
		return { ...response };
	}

	async attachEvidence(inspectionId: number, itemId: number, form: FormData) {
		const response = await this.axiosInstanceMultipart
			.post<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}/item/${itemId}/evidence`, form);
		return { ...response };
	}

	async cancel(inspectionId: number, reason: string) {
		const response = await this.axiosInstance
			.put<EpiInspectionFlowDTO>(`/epi-inspections/flow/${inspectionId}/cancel`, { reason });
		return { ...response };
	}
}
